import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["context"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component, useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
export default (function (InnerComponent, componentType) {
  function isTargetComponent(message) {
    return message.componentType === componentType;
  }
  function computeNewState(state) {
    var current = state.current;
    if (current && isTargetComponent(current)) {
      var message;
      switch (current.componentType) {
        case 'contextualSurvey':
          message = _objectSpread(_objectSpread({}, current), {}, {
            aaid: state.config.aaid,
            cloudId: state.config.cloudId,
            stargateUrl: state.config.stargateUrl,
            product: state.config.product,
            orgId: state.config.orgId,
            workspaceId: state.config.workspaceId
          });
          break;
        default:
          message = current;
      }
      return {
        message: message
      };
    }
    return {
      message: null
    };
  }
  function getComponentType() {
    return componentType;
  }

  // eslint-disable-next-line @repo/internal/react/no-class-components
  var StoreWrapper = /*#__PURE__*/function (_Component) {
    function StoreWrapper() {
      _classCallCheck(this, StoreWrapper);
      return _callSuper(this, StoreWrapper, arguments);
    }
    _inherits(StoreWrapper, _Component);
    return _createClass(StoreWrapper, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(StoreWrapperInner, _extends({}, this.props, {
          context: this.context
        }));
      }
    }]);
  }(Component);
  _defineProperty(StoreWrapper, "contextTypes", {
    subscribeEngagementState: PropTypes.func,
    setComponentConfig: PropTypes.func
  });
  var StoreWrapperInner = function StoreWrapperInner(allProps) {
    var context = allProps.context,
      props = _objectWithoutProperties(allProps, _excluded);
    var children = props.children,
      engagementId = props.engagementId,
      messageType = props.messageType,
      onMessageDisposition = props.onMessageDisposition;
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];
    var unsubscribeRef = useRef(null);
    var removeConfigRef = useRef(null);
    var canSubscribe = useCallback(function () {
      return context && !!(context !== null && context !== void 0 && context.subscribeEngagementState);
    }, [context]);
    var canSetConfig = useCallback(function () {
      return context && !!(context !== null && context !== void 0 && context.setComponentConfig);
    }, [context]);
    var onStoreChange = useCallback(function (state) {
      setMessage(computeNewState(state).message);
    }, []);
    var subscribeToStore = useCallback(function () {
      var _context$subscribeEng;
      return context === null || context === void 0 || (_context$subscribeEng = context.subscribeEngagementState) === null || _context$subscribeEng === void 0 ? void 0 : _context$subscribeEng.call(context, onStoreChange);
    }, [context, onStoreChange]);
    var setChoreographerConfig = useCallback(function () {
      var _context$setComponent;
      var propsToUse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : props;
      return context === null || context === void 0 || (_context$setComponent = context.setComponentConfig) === null || _context$setComponent === void 0 ? void 0 : _context$setComponent.call(context, getComponentType(), {
        messageType: propsToUse.messageType,
        onMessageDisposition: propsToUse.onMessageDisposition
      }, propsToUse.engagementId);
    }, [context, props]);

    // Handle initial mount (equivalent to UNSAFE_componentWillMount)
    useEffect(function () {
      if (canSubscribe()) {
        unsubscribeRef.current = subscribeToStore() || null;
      }
      if (canSetConfig()) {
        removeConfigRef.current = setChoreographerConfig() || null;
      }
      return function () {
        if (unsubscribeRef.current) {
          unsubscribeRef.current();
        }
        if (removeConfigRef.current) {
          removeConfigRef.current();
        }
      };
    }, [canSubscribe, canSetConfig, subscribeToStore, setChoreographerConfig]);

    // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
    var previousEngagementId = useRef(engagementId);
    var previousMessageType = useRef(messageType);
    var previousOnMessageDisposition = useRef(onMessageDisposition);
    useEffect(function () {
      if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
        removeConfigRef.current();
        removeConfigRef.current = setChoreographerConfig(props) || null;
      } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) {
        setChoreographerConfig(props);
      }
      previousEngagementId.current = engagementId;
      previousMessageType.current = messageType;
      previousOnMessageDisposition.current = onMessageDisposition;
    }, [props, setChoreographerConfig, canSetConfig, engagementId, messageType, onMessageDisposition]);
    if (!message) {
      if (componentType === 'inlineDialog') {
        return children || null;
      }
      return null;
    }
    if (engagementId && message !== null && message.target && engagementId !== message.target) {
      return null;
    }
    var messageKey = "".concat(message.messageId, ".").concat(message.variationId, ".").concat(message.componentId);

    // Key is useful here to make sure that when the currently active
    // messages changes, the old component is unmounted (therefore
    // firing an analytic event for hiding the component) and mounting
    // a new component for the new message (firing a shown event for
    // the new message). Not using key would allow React to apply an
    // optimization that would reuse the current component for a new
    // message which would not call the normal mount and unmount
    // lifecycle methods.
    return /*#__PURE__*/React.createElement(InnerComponent, _extends({
      key: messageKey
    }, props, message));
  };
  return StoreWrapper;
});